<template>
  <Grid gtc="3fr 1fr" gap="var(--r-space-sp)">
    <RCard class="product-information relative-position">
      <template v-if="product">
        <Grid gaf="column" justify-content="space-between" align-items="center">
          <div class="text-subtitle-1 text-secondary-2">Product information</div>
          <RBtn type="link" :to="{ name: 'product', params: { id: product.id } }">go to product</RBtn>
        </Grid>

        <div class="content-summary full-width q-mt-md" v-html="product.content_summary" />
      </template>

      <QInnerLoading :showing="!product">
        <QSpinnerHourglass size="3.5rem" color="primary-1" />
      </QInnerLoading>
    </RCard>

    <RCard class="metadata relative-position">
      <CustomMetaData v-if="selectedPeriodId" :entity-id="selectedPeriodId" entity-name="subscription-period">
        <template #below-title>
          <RDropdown
            v-model="selectedPeriodId"
            emit-value
            map-options
            no-hint
            label="Select period"
            :options="periodsOptions"
            style="width: 200px"
          />
          <div class="q-pt-md"></div>
        </template>
      </CustomMetaData>

      <QInnerLoading :showing="!selectedPeriodId">
        <QSpinnerHourglass size="3.5rem" color="primary-1" />
      </QInnerLoading>
    </RCard>
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { mapGetters } from 'vuex'
// Components
import CustomMetaData from '@/reusable/custom-meta-data/CustomMetaData'

export default {
  components: {
    CustomMetaData
  },

  props: {
    id: [Number, String] // from route
  },

  data: () => ({
    product: null,
    selectedPeriodId: null
  }),

  computed: {
    ...mapGetters('subscription-show', ['subscription', 'subscriptionPeriods']),

    periodsOptions() {
      return this.subscriptionPeriods.map(period => {
        return {
          label: `${this.formatDateForLocale(period.start_date)} - ${this.formatDateForLocale(period.end_date)}`,
          value: period.id
        }
      })
    }
  },

  watch: {
    subscription: {
      handler: 'getProduct',
      immediate: true
    }
  },

  methods: {
    getProduct(subscription) {
      if (!subscription) return
      apiTo.GET_PRODUCT(subscription.product.id).then(({ data }) => {
        this.product = data.result
        this.selectedPeriodId = this.subscription.current?.id || this.subscription.next?.id
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.product-information {
  .content-summary {
    list-style-position: inside;
  }
}
</style>
